import type { ItemListId } from "../../tracking/create-ecommerce-event";

export const VD_ITEM_LIST_IDS_STORAGE_KEY = "vd_item_list_ids";

export const writeVdItemListIds = (map: Record<string, ItemListId>): void => {
  try {
    if (Object.keys(map).length === 0) return;
    sessionStorage.setItem(VD_ITEM_LIST_IDS_STORAGE_KEY, JSON.stringify(map));
  } catch {
    // sessionStorage may be unavailable (SSR / private mode); ignore.
  }
};

// Read + consume in one shot: malformed or stale JSON would otherwise throw before
// safeTrackEvent gets a chance to wrap it, aborting the TYP onSuccess callback (and
// silently re-tripping deduplication on the next attempt). Always returns a record;
// always removes the storage entry, even on parse failure, so we don't keep tripping.
export const consumeVdItemListIds = (): Record<string, ItemListId> => {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(VD_ITEM_LIST_IDS_STORAGE_KEY);
  } catch {
    return {};
  }
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as Record<string, ItemListId>) : {};
  } catch {
    return {};
  } finally {
    try {
      sessionStorage.removeItem(VD_ITEM_LIST_IDS_STORAGE_KEY);
    } catch {
      // best-effort cleanup
    }
  }
};
